import { createFeatureSelector } from "@ngrx/store";

import { AchBoStatusState } from "../models/consumer-logs/ach-bo-status-state";
import { AchDocumentState } from "../models/consumer-logs/ach-document-state";
import { AchStatusState } from "../models/consumer-logs/ach-status-state";
import { StoreKeys } from "../store-keys";

export class ConsumerTransactionSelectors {
	static readonly achDocs = createFeatureSelector<AchDocumentState>(
		StoreKeys.achDocumentStateKey
	);
	static readonly achBoStatus = createFeatureSelector<AchBoStatusState>(
		StoreKeys.achBoStatusStateKey
	);
	static readonly achStatus = createFeatureSelector<AchStatusState>(StoreKeys.achStatusStateKey);
}
